import React from "react";
import { Link, Navigate,useNavigate } from "react-router";
import {
  FiPlus,
  FiSearch,
  FiEdit2,
  FiTrash2,
} from "react-icons/fi";

function Meetinglist() {
    const navigate = useNavigate();
  return (
    <div>
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>Meeting List</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>Meeting List</span>
          </nav>
        </div>

        <div className="page-title fw-semibold fs-18 mb-0">
          <Link to="/add-meeting" className="add-btn">
            <FiPlus className="me-2" />
            Add Meeting
          </Link>
        </div>
      </div>

      <div className="main_page">
        <div className="card">
          <div className="card-body">

            {/* Search Section */}
            <div className="row mb-3">

              <div className="col-md-4">
                <input
                  type="text"
                  className="form-control custumform"
                  placeholder="Search Meeting..."
                />
              </div>

              <div className="col-md-3">
                <select className="form-control custumform">
                  <option>All Status</option>
                  <option>Scheduled</option>
                  <option>Completed</option>
                  <option>Cancelled</option>
                </select>
              </div>

              <div className="col-md-3">
                <select className="form-control custumform">
                  <option>All Meeting Type</option>
                  <option>Online</option>
                  <option>Offline</option>
                  <option>Video Call</option>
                  <option>Phone Call</option>
                </select>
              </div>

              <div className="col-md-2">
                <button className="total_btn lead-btn btn-import w-100">
                  <FiSearch className="me-2" />
                  Search
                </button>
              </div>

            </div>

            {/* Table */}
            <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">

                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Meeting Title</th>
                    <th>Client Name</th>
                    <th>Project</th>
                    <th>Meeting Person</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>

                  <tr>
                    <td>1</td>
                    <td>Project Discussion</td>
                    <td>ABC Pvt Ltd</td>
                    <td>HRM System</td>
                    <td>Rohit Kumar</td>
                    <td>25-07-2026</td>
                    <td>10:30 AM</td>
                    <td>
                      <span className="badge bg-primary">
                        Online
                      </span>
                    </td>
                    <td>
                      <span className="badge bg-warning text-dark">
                        Scheduled
                      </span>
                    </td>
                    <td className="text-center">
                      <div className="d-flex gap-2 justify-content-center">
                        <button
                        onClick={() => navigate('/edit-meeting')}
                          className="st-action-btn st-view-btn"
                          title="Edit"
                        >
                        
                          <FiEdit2 />
                        </button>

                        <button
                          className="st-action-btn st-delete-btn"
                          title="Delete"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>2</td>
                    <td>Requirement Gathering</td>
                    <td>XYZ Technologies</td>
                    <td>CRM Software</td>
                    <td>Deepak Verma</td>
                    <td>26-07-2026</td>
                    <td>02:00 PM</td>
                    <td>
                      <span className="badge bg-success">
                        Offline
                      </span>
                    </td>
                    <td>
                      <span className="badge bg-success">
                        Completed
                      </span>
                    </td>
                    <td className="text-center">
                      <div className="d-flex gap-2 justify-content-center">
                        <button
                          className="st-action-btn st-view-btn"
                          title="Edit"
                        >
                          <FiEdit2 />
                        </button>

                        <button
                          className="st-action-btn st-delete-btn"
                          title="Delete"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>3</td>
                    <td>UI Review</td>
                    <td>Future Skill</td>
                    <td>LMS Portal</td>
                    <td>Amit Kumar</td>
                    <td>27-07-2026</td>
                    <td>11:00 AM</td>
                    <td>
                      <span className="badge bg-info text-dark">
                        Video Call
                      </span>
                    </td>
                    <td>
                      <span className="badge bg-danger">
                        Cancelled
                      </span>
                    </td>
                    <td className="text-center">
                      <div className="d-flex gap-2 justify-content-center">
                        <button
                          className="st-action-btn st-view-btn"
                          title="Edit"
                        >
                          <FiEdit2 />
                        </button>

                        <button
                          className="st-action-btn st-delete-btn"
                          title="Delete"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>4</td>
                    <td>Client Demo</td>
                    <td>A2 TechnoSoft</td>
                    <td>School ERP</td>
                    <td>Admin</td>
                    <td>28-07-2026</td>
                    <td>04:30 PM</td>
                    <td>
                      <span className="badge bg-primary">
                        Online
                      </span>
                    </td>
                    <td>
                      <span className="badge bg-warning text-dark">
                        Scheduled
                      </span>
                    </td>
                    <td className="text-center">
                      <div className="d-flex gap-2 justify-content-center">
                        <button
                          className="st-action-btn st-view-btn"
                          title="Edit"
                        >
                          <FiEdit2 />
                        </button>

                        <button
                          className="st-action-btn st-delete-btn"
                          title="Delete"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>5</td>
                    <td>Final Project Handover</td>
                    <td>Global IT</td>
                    <td>Inventory System</td>
                    <td>Rohit Kumar</td>
                    <td>30-07-2026</td>
                    <td>01:30 PM</td>
                    <td>
                      <span className="badge bg-success">
                        Offline
                      </span>
                    </td>
                    <td>
                      <span className="badge bg-success">
                        Completed
                      </span>
                    </td>
                    <td className="text-center">
                      <div className="d-flex gap-2 justify-content-center">
                        <button
                          className="st-action-btn st-view-btn"
                          title="Edit"
                        >
                          <FiEdit2 />
                        </button>

                        <button
                          className="st-action-btn st-delete-btn"
                          title="Delete"
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </td>
                  </tr>

                </tbody>

              </table>
            </div>

          </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Meetinglist;